var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hshead',{attrs:{"title":"帮助中心","bgcolor":"#fff"}}),_vm._v(" "),_c('div',{staticClass:"hkHelpText"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.helpImagesText)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30511ec0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/store/hkHelp.vue
// module id = null
// module chunks = 